import React from "react"
import ListPageContainer from "../../Common/jsx/ListPageContainer"
import { getEntitiesUrlParameters } from "../../Common/js/get_entities_url_parameters"
import withHooks from "../../Common/jsx/WithHooks"
import { getPlants } from "../../api/api_plant"
import { ucFirst } from "../../Common/js/generic_functions"
import { Col, Row } from "react-bootstrap"
import GGPlantId from "./GGPlantId"
import { getObjectIdKey } from "../../Common/js/getObjectIdKey"
import { getFamilies } from "../../api/api_family"

class GGPlantsList extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)
    this.state = {
      isReadyToRender: false,
      currentPlant: {},
      listPagination: {
        itemsPerPage: 20,
        page: 1,
        totalItems: -1,
        firstPageUrl: "",
        lastPageUrl: "",
        previousPageUrl: "",
        nextPageUrl: "",
      },
      listOrders: {
        name: "asc",
      },
      listFilters: {
        isVisible: true,
        searchStrings: "",
      },
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntities = this.getEntities.bind(this)
    this.getHeaders = this.getHeaders.bind(this)
    this.getFilters = this.getFilters.bind(this)
    this.getRows = this.getRows.bind(this)
    this.buildEntity = this.buildEntity.bind(this)
    this.listPaginationUpdate = this.listPaginationUpdate.bind(this)
    this.listOrdersUpdate = this.listOrdersUpdate.bind(this)
    this.listFiltersUpdate = this.listFiltersUpdate.bind(this)
    this.displayPlantId = this.displayPlantId.bind(this)
    this.setCurrentPlant = this.setCurrentPlant.bind(this)
  }

  componentDidMount() {
    this.getRelatedEntities()
  }

  getRelatedEntities() {
    // CONFIG ==================================================================================================
    Promise.all([getFamilies({ itemsPerPage: 10000 }), getPlants({ itemsPerPage: 10000 })]).then((promisesResults) => {
      let [families, plants] = promisesResults
      this.dMgr.debug("getRelatedEntities done")

      this.setState(
        {
          families: families["hydra:member"],
          familiesAsObject: getObjectIdKey(families["hydra:member"]),
          plants: plants["hydra:member"],
          plantsAsObject: getObjectIdKey(plants["hydra:member"]),
        },
        this.getEntities,
      )
    })
    // /CONFIG =================================================================================================
  }

  async getEntities() {
    let parameters = getEntitiesUrlParameters(this.state.listPagination, this.state.listFilters, this.state.listOrders)

    // CONFIG ------------------------------------------------------------------------------------------------
    let entities = await getPlants(parameters)

    let currentPlantId = this.props.entityId || 1
    let entitiesByKeys = getObjectIdKey(entities["hydra:member"])
    // / CONFIG ----------------------------------------------------------------------------------------------

    let listPagination = {
      ...this.state.listPagination,
      ...{
        totalItems: entities["hydra:totalItems"],
        pageTypeUrl: entities["hydra:view"]["@id"],
        firstPageUrl: entities["hydra:view"]["hydra:first"],
        lastPageUrl: entities["hydra:view"]["hydra:last"],
        previousPageUrl: entities["hydra:view"]["hydra:previous"],
        nextPageUrl: entities["hydra:view"]["hydra:next"],
      },
    }

    this.setState({
      isReadyToRender: true,
      listPagination,
      entities: entities["hydra:member"],
      entitiesById: entitiesByKeys,
      currentPlant: this.state.plantsAsObject[currentPlantId],
    })
  }

  setCurrentPlant(plantId) {
    console.log(plantId)

    this.setState({
      currentPlant: this.state.plantsAsObject[plantId],
    })
  }

  // CONFIG ------------------------------------------------------------------------------------------------

  getHeaders() {
    return [
      {
        name: "nameStr",
        title: "Nom",
        sort: this.state.listOrders.nameStr !== undefined ? this.state.listOrders.nameStr : "",
      },
    ]
  }

  getFilters() {
    return [
      {
        name: "searchStrings",
        type: "text",
        label: this.props.t("app.search"),
        value: this.state.listFilters.searchStrings,
      },
      {
        name: "family.id",
        type: "select",
        options: [
          {
            value: "",
            label: "Toutes les familles",
          },
        ].concat(
          this.state.families
            .map((family) => {
              return {
                value: family.id,
                label: family.name,
              }
            })
            .sort((a, b) => a.label.localeCompare(b.label)),
        ),
        value: this.state.listFilters.families,
      },
    ]
  }

  buildEntity(entity) {
    entity.customFields = []

    return entity
  }

  getRows() {
    return this.state.entities.map((entity) => {
      entity = this.buildEntity(entity)

      return {
        entity: entity,
        fields: [
          {
            name: "nameStr",
            value: ucFirst(entity.nameStr),
            paramId: entity.id,
            callback: {
              callbackFunction: (paramId) => {
                this.displayPlantId(paramId)
              },
            },
          },
        ],
      }
    })
  }
  // /CONFIG ------------------------------------------------------------------------------------------------

  listPaginationUpdate(parameters) {
    this.dMgr.debug("listPaginationUpdate parameters:", parameters)
    this.setState({ listPagination: { ...this.state.listPagination, ...parameters } }, this.getEntities)
  }

  listOrdersUpdate(order) {
    this.dMgr.debug("listOrdersUpdate order:", order)

    let listOrders = {}
    if (this.state.listOrders[order] !== undefined) {
      if (this.state.listOrders[order] === "asc") {
        listOrders[order] = "desc"
      } else {
        listOrders[order] = "asc"
      }
    } else {
      listOrders[order] = "asc"
    }
    this.setState({ listOrders: listOrders }, this.getEntities)
  }

  listFiltersUpdate(filters) {
    this.dMgr.debug("listFiltersUpdate filters:", filters)
    this.setState({ listFilters: { ...this.state.listFilters, ...filters } }, this.getEntities)
  }

  displayPlantId(plantId) {
    this.dMgr.debug("displayPlantId :", plantId)

    this.setState({ currentPlant: this.state.entitiesById[plantId] })
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <>
        <br />
        <Row>
          <Col md={3}>
            <ListPageContainer
              tableName={"list_" + this.props.entitiesType}
              referrerUrl={"/plants"}
              entityType={this.props.entityType}
              tableHeaders={this.getHeaders()}
              tableRows={this.getRows()}
              filters={this.getFilters()}
              listPagination={this.state.listPagination}
              listPaginationUpdate={this.listPaginationUpdate}
              listOrdersUpdate={this.listOrdersUpdate}
              listFilters={this.state.listFilters}
              listFiltersUpdate={this.listFiltersUpdate}
              topCard={true}
              tableNoItemsCounts={true}
              tableNoItemsPerPage={true}
              noAddButton={true}
            />
          </Col>
          <Col md={9}>
            <GGPlantId plant={this.state.currentPlant} setCurrentPlant={this.setCurrentPlant} />
          </Col>
        </Row>
      </>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(GGPlantsList)
